import { useState } from "react";
import api from "../api/api";

function AddNewspaper() {
  const [open, setOpen] = useState(false);
  const [name,         setName]         = useState("");
  const [language,     setLanguage]     = useState("");
  const [dailyPrice,   setDailyPrice]   = useState("");
  const [monthlyPrice, setMonthlyPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  const add = async () => {
    if (!name || !dailyPrice || !monthlyPrice) {
      setError("Please fill all required fields");
      return;
    }
    setError(""); setLoading(true);
    try {
      await api.post("/admin/newspaper", { name, language, dailyPrice, monthlyPrice });
      setName(""); setLanguage(""); setDailyPrice(""); setMonthlyPrice("");
      setOpen(false);
      window.location.reload();
    } catch {
      setError("Failed to add newspaper. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="section-hdr">
        <div className="section-hdr-title">Newspapers</div>
        <button className="btn btn-primary" onClick={() => setOpen(!open)}>
          {open ? "✕ Cancel" : "＋ Add Newspaper"}
        </button>
      </div>

      {open && (
        <div className="card mb-24">
          <div className="card-header">
            <div className="card-title">Add New Newspaper</div>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-error mb-16">⚠ {error}</div>}

            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Paper Name *</label>
                <input className="form-input" placeholder="e.g. The Times of India"
                  value={name} onChange={e => setName(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Language</label>
                <input className="form-input" placeholder="e.g. English, Kannada"
                  value={language} onChange={e => setLanguage(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Daily Price (₹) *</label>
                <input className="form-input" type="number" placeholder="e.g. 4"
                  value={dailyPrice} onChange={e => setDailyPrice(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Monthly Package (₹) *</label>
                <input className="form-input" type="number" placeholder="e.g. 90"
                  value={monthlyPrice} onChange={e => setMonthlyPrice(e.target.value)} />
              </div>
            </div>

            <div className="flex-center gap-8 mt-16">
              <button className="btn btn-gold" onClick={add} disabled={loading}>
                {loading ? "Adding…" : "Add Newspaper"}
              </button>
              <button className="btn btn-outline" onClick={() => { setOpen(false); setError(""); }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddNewspaper;
